/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getJobAttachment } from "../../actions/jobs";

class JobAttachment extends Component {
  state = {
    fetched: false
  };

  componentDidMount() {
    const { runsheetId, jobId } = this.props;
    this.props
      .getJobAttachment(runsheetId, jobId)
      .then(() => this.setState({ fetched: true }));
  }

  render() {
    if (this.state.fetched) {
      const { jobAttachments } = this.props;
      const data = jobAttachments.map(jobAttachment => (
        <tr key={jobAttachment.id}>
          <td className="attachment">
            <img
              data-rotate="0"
              src={`data:image/png;base64, ${jobAttachment.attachment.content}`}
              alt="attachment"
            />
          </td>
          <td>{jobAttachment.notes}</td>
        </tr>
      ));

      return <tbody className="content">{data}</tbody>;
    }

    return (
      <tbody>
        <tr />
      </tbody>
    );
  }
}
JobAttachment.propTypes = {
  runsheetId: PropTypes.string.isRequired,
  jobId: PropTypes.number.isRequired,
  getJobAttachment: PropTypes.func.isRequired,
  jobAttachments: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  return { jobAttachments: state.jobAttachments.allAttachments };
}

export default connect(mapStateToProps, { getJobAttachment })(JobAttachment);



// WEBPACK FOOTER //
// ./src/components/jobs/JobAttachment.js